module.exports = __webpack_public_path__ + "media/images/static/top/urban/left-1b35b83b31804bb31e5771632a3a810e.png";